import create from 'zustand';
import { FormValues } from 'src/pages/Data/Data'
import { FormValues as FormValues2 } from 'src/components/SearchForm/SearchForm'//20230420追記

type Store = {
  searchCondition: FormValues | null,
  vermins: [],
  proc:string | null;
  ids: number[];
  searchCheck: FormValues2 | null,
  setVermins: (verminsData: []
  ) => void;
  deleteVermins: () => void;
  setSearchCondition: (searchData: FormValues) => void;
  deleteSearchCondition: () => void;
  setProc: (procData: string) => void;
  deleteProc: () => void;
  setIds: (verminsData: []) => void;
  deleteIds: () => void;
  searchS: (searchData: FormValues2) => void;
  searchE: () => void;
};

/**
 * 検索結果管理ストア
 */
const useVermins = create<Store>(set => ({
  vermins: [],
  proc: null,
  ids: [],
  searchCheck: null,
  searchCondition: null,
  setVermins: verminsData => set({ vermins: verminsData }),
  deleteVermins: () => set({ vermins: [] }),
  setSearchCondition: searchData => set({ searchCondition: searchData }),
  deleteSearchCondition: () => set({ searchCondition: null }),
  setProc: procData => set({ proc: procData }),
  deleteProc: () => set({ proc: null }),
  setIds: idsData => set({ ids: idsData }),
  deleteIds: () => set({ ids: [] }),
  searchS: searchData => set({ searchCheck: searchData }),
  searchE: () => set({ searchCheck: null }),
}));

export default useVermins;